import {
  BuildingStorefrontIcon,
  CalendarIcon,
  ChatBubbleBottomCenterTextIcon,
  InformationCircleIcon,
  MapPinIcon,
  UserIcon,
} from '@heroicons/react/20/solid';
import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PillLabel from '../../../components/PillLabel';
import { fetchOrderRestaurants } from '../../../features/order/order';
import { TTOrderV2 } from '../../../interfaces/order';
import { useAppDispatch } from '../../../store';
import {
  RestaurantAddress,
  TTRestaurantProfile,
} from '../../../interfaces/restaurant';
import { TTUserProfile } from '../../../interfaces/user';
import { RootState } from '../../../rootReducer';

type Props = {};

export function OrderCateringDetails() {
  const order = useSelector<RootState, TTOrderV2 | null>(
    state => state.order.order,
  );

  const guest = useSelector<RootState, TTUserProfile | null>(
    state => state.auth.userProfile,
  );

  const restaurant_profiles = useSelector<RootState, TTRestaurantProfile[]>(
    state => state.order.order_restaurants,
  );
  const restaurant_addresses = useSelector<RootState, RestaurantAddress[]>(
    state => state.order.order_restaurant_addresses,
  );
  const dispatch = useAppDispatch();
  const [showDetails, setShowDetails] = useState({});
  useEffect(() => {
    if (order !== null) {
      dispatch(fetchOrderRestaurants(order));
    }
  }, [order]);

  if (!order) return <></>;
  return (
    <>
      {order?.order_tabs
        ?.map(tab => tab.order_fulfillments)
        ?.reduce((a, b) => a.concat(b), [])
        ?.filter(fulfillment => fulfillment.guest_id === guest?.id)
        ?.map(fulfillment => {
          return (
            <div
              className="flex flex-col rounded-md bg-secondary-container shadow-md mx-6 my-4 px-2 py-1 space-y-2"
              key={fulfillment?.id?.toString()}
            >
              <div className="flex flex-col  ">
                <div className="flex space-x-1 items-center">
                  <BuildingStorefrontIcon className="w-4 h-4 text-primary" />

                  <div className="text-sm text-primary">Vendor Name</div>
                </div>
                <div className="text-md text-on-secondary-container font-semibold">
                  {restaurant_profiles?.filter(
                    r =>
                      r.restaurant_id ===
                      order?.order_tabs?.filter(
                        t => t.id === fulfillment?.order_tab_id,
                      )[0]?.restaurant_id,
                  )[0]?.name ?? ''}
                </div>
              </div>
              <div className="h-0.5 w-full bg-outline mx-auto" />
              <div className="flex flex-col  ">
                <div className="flex space-x-1 items-center">
                  <BuildingStorefrontIcon className="w-4 h-4 text-primary" />

                  <div className="text-sm text-primary">Vendor Address</div>
                </div>
                <div className="text-md text-on-secondary-container font-semibold">
                  {restaurant_addresses?.filter(
                    r =>
                      r.restaurant_id ===
                      order?.order_tabs?.filter(
                        t => t.id === fulfillment?.order_tab_id,
                      )[0]?.restaurant_id,
                  )[0]?.address_line_1 +
                    ', ' +
                    restaurant_addresses?.filter(
                      r =>
                        r.restaurant_id ===
                        order?.order_tabs?.filter(
                          t => t.id === fulfillment?.order_tab_id,
                        )[0]?.restaurant_id,
                    )[0]?.city +
                    ', ' +
                    restaurant_addresses?.filter(
                      r =>
                        r.restaurant_id ===
                        order?.order_tabs?.filter(
                          t => t.id === fulfillment?.order_tab_id,
                        )[0]?.restaurant_id,
                    )[0]?.administrative_area_level_1 +
                    ', ' +
                    restaurant_addresses?.filter(
                      r =>
                        r.restaurant_id ===
                        order?.order_tabs?.filter(
                          t => t.id === fulfillment?.order_tab_id,
                        )[0]?.restaurant_id,
                    )[0]?.zip_postal ?? ''}
                </div>
              </div>
              <div className="h-0.5 w-full bg-outline mx-auto" />
              <div className="flex flex-col   ">
                <div className="flex space-x-1 items-center">
                  <InformationCircleIcon className="w-4 h-4 text-primary" />

                  <div className="text-sm text-gray-600">Status</div>
                </div>

                <div className="text-md text-gray-900 font-semibold">
                  {fulfillment?.state === 'pending' ? (
                    <PillLabel
                      label="Pending"
                      color="bg-indigo-700"
                      label_size="text-md"
                      text_color="text-indigo-200"
                    />
                  ) : fulfillment?.state === 'accepted' ? (
                    <PillLabel
                      label="Accepted"
                      color="bg-green-700"
                      label_size="text-md"
                      text_color="text-green-200"
                    />
                  ) : fulfillment?.state === 'ready' ? (
                    <PillLabel
                      label="Ready"
                      color="bg-green-700"
                      label_size="text-md"
                      text_color="text-green-200"
                    />
                  ) : fulfillment?.state === 'completed' ? (
                    <PillLabel
                      label="Completed"
                      color="bg-green-700"
                      label_size="text-md"
                      text_color="text-green-200"
                    />
                  ) : (
                    <PillLabel
                      label="Canceled"
                      color="bg-inverse-surface"
                      label_size="text-md"
                      text_color="text-on-inverse-surface"
                    />
                  )}
                </div>
              </div>
              <div className="h-0.5 w-full bg-gray-300 mx-auto" />
              {showDetails[fulfillment?.id] ? (
                <>
                  <div className="flex flex-col  ">
                    <div className="flex space-x-1 items-center">
                      <UserIcon className="w-4 h-4 text-primary" />

                      <div className="text-sm text-primary">Name</div>
                    </div>
                    <div className="text-md text-on-secondary-container font-semibold">
                      {guest?.first_name}
                    </div>
                  </div>
                  <div className="h-0.5 w-full bg-outline mx-auto" />

                  <div className="flex flex-col  ">
                    <div className="flex space-x-1 items-center">
                      <CalendarIcon className="w-4 h-4 text-primary" />
                      <div className="text-sm text-primary">
                        Catering Date & Time
                      </div>
                    </div>

                    <time className="text-md text-on-secondary-container font-semibold">
                      {moment
                        .utc(fulfillment?.catering_details?.scheduled_for)
                        .local()
                        .format('MM/DD/YYYY, h:mm a')}
                    </time>
                  </div>
                  <div className="h-0.5 w-full bg-gray-300 mx-auto" />
                  {fulfillment?.catering_details?.is_delivered ? (
                    <div className="flex flex-col justify-between ">
                      <div className="flex space-x-1 items-center">
                        <MapPinIcon className="w-4 h-4 text-primary" />

                        <div className="text-sm text-primary">
                          Delivery Address
                        </div>
                      </div>

                      <address className="text-md text-on-secondary-container  mb-0 font-semibold">
                        {fulfillment?.guest_address?.address_line_1 +
                          ', ' +
                          fulfillment?.guest_address?.city +
                          ', ' +
                          fulfillment?.guest_address
                            ?.administrative_area_level_1 +
                          ', ' +
                          fulfillment?.guest_address?.country +
                          ' ' +
                          fulfillment?.guest_address?.zip_postal}
                      </address>
                    </div>
                  ) : (
                    <div className="flex flex-col justify-between ">
                      <div className="flex space-x-1 items-center">
                        <MapPinIcon className="w-4 h-4 text-primary" />

                        <div className="text-sm text-primary">
                          Pickup Location
                        </div>
                      </div>
                      <address className="text-md text-on-secondary-container mb-0">
                        {fulfillment?.guest_address?.address_line_1 +
                          ', ' +
                          fulfillment?.guest_address?.city +
                          ', ' +
                          fulfillment?.guest_address
                            ?.administrative_area_level_1 +
                          ', ' +
                          fulfillment?.guest_address?.country +
                          ' ' +
                          fulfillment?.guest_address?.zip_postal}
                      </address>
                    </div>
                  )}
                  <div className="h-0.5 w-full bg-gray-300 mx-auto" />

                  <div className="flex flex-col  ">
                    <div className="flex space-x-1 items-center">
                      <CalendarIcon className="w-4 h-4 text-primary" />

                      <div className="text-sm text-primary">
                        Order Placed at
                      </div>
                    </div>
                    <time className="text-md text-on-secondary-container font-semibold">
                      {moment
                        .utc(fulfillment?.created_at)
                        .local()
                        .format('MM/DD/YYYY, h:mm a')}
                    </time>
                  </div>
                  <div className="h-0.5 w-full bg-outline mx-auto" />
                  <div className="flex flex-col  ">
                    <div className="flex space-x-1 items-center">
                      <ChatBubbleBottomCenterTextIcon className="w-4 h-4 text-primary" />

                      <div className="text-sm text-primary">Comment</div>
                    </div>
                    <p className="text-md text-on-secondary-container mb-0 font-semibold">
                      {fulfillment?.catering_details?.note ?? ''}
                    </p>
                  </div>
                  <>
                    <div>
                      <div
                        className="flex flex-row justify-center items-center rounded-full px-2 py-1 bg-secondary/70 text-center text-on-secondary"
                        onClick={() => {
                          let details = { ...showDetails };
                          details[fulfillment?.id] = false;
                          setShowDetails({ ...details });
                        }}
                      >
                        Hide Details
                      </div>
                    </div>
                  </>
                </>
              ) : (
                <>
                  <div>
                    <div
                      className="flex flex-row justify-center items-center rounded-full px-2 py-1 bg-secondary/70 text-center text-on-secondary"
                      onClick={() => {
                        let details = { ...showDetails };
                        details[fulfillment?.id] = true;
                        setShowDetails({ ...details });
                      }}
                    >
                      View Details
                    </div>
                  </div>
                </>
              )}
            </div>
          );
        })}
    </>
  );
}
